import Vue from 'vue';
import Vuetify from 'vuetify/lib';

import type { Framework } from 'vuetify';

Vue.use(Vuetify);

export default new Vuetify({
  icons: {
    iconfont: 'mdiSvg',
  },
  theme: {
    themes: {
      light: {
        primary: '#0070c5',
        accent: '#00b77e',
        secondary: '#e5eef7',
        info: '#2196f3',
        warning: '#ffc107',
        error: '#ff5252',
        success: '#4caf50',
      },
    },
  },
});

declare module 'vue/types/vue' {
  export interface Vue {
    $vuetify: Framework;
  }
}
